import React, { useEffect, useState } from "react";
import {
  getCompanyDetails,
  getLoggedInUser,
} from "../../helpers/backend_helper";

const display = (value) => value || "-";

const SettingsGeneral = () => {
  const [firm, setFirm] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLoggedInUser()
      .then((user) => (user?.firmId ? getCompanyDetails(user.firmId) : null))
      .then((response) => {
        if (response?.data) setFirm(response.data);
      })
      .catch((error) => console.error("Unable to load firm settings.", error))
      .finally(() => setLoading(false));
  }, []);

  const fields = [
    ["Firm name", firm.name, "bx-building-house", "blue"],
    ["Primary contact", firm.primaryContactName, "bx-user", "blue"],
    ["Contact number", firm.contactNo, "bx-phone", "green"],
    ["Email address", firm.emailId, "bx-envelope", "purple"],
    ["Website", firm.webSite, "bx-globe", "orange"],
  ];

  return (
    <section className="settings-general">
      <section className="settings-general__hero">
        <div className="settings-general__hero-icon">
          <i className="bx bx-building-house" />
        </div>
        <div>
          <span>Firm profile</span>
          <h2>{display(firm.name)}</h2>
          <p>
            Keep your organization contact details current for users and
            engagements.
          </p>
        </div>
      </section>
      <section
        className="settings-general__panel"
        data-onboarding-target="firm"
        tabIndex="-1"
      >
        <div className="settings-general__heading">
          <div>
            <i className="bx bx-cog" />
            <span>General information</span>
          </div>
          {loading && <small>Loading firm details...</small>}
        </div>
        <div className="settings-general__details">
          {fields.map(([label, value, icon, tone]) => (
            <div className="settings-general__detail" key={label}>
              <i
                className={`bx ${icon} settings-general__detail-icon settings-general__detail-icon--${tone}`}
              />
              <div>
                <small>{label}</small>
                <strong>{display(value)}</strong>
              </div>
            </div>
          ))}
        </div>
        <div className="settings-general__address">
          <div className="settings-general__address-icon">
            <i className="bx bx-map" />
          </div>
          <div>
            <small>Registered address</small>
            <strong>{display(firm.address)}</strong>
          </div>
        </div>
      </section>
    </section>
  );
};

export default SettingsGeneral;
